import { getApiUrl } from "@hunkware-ui/common";

/**
 * Getting env variable
 * @throwable
 */
const getEnvVar = (key: string): string => {
  // Use the process.env approach for environments without import.meta.env
  const value = import.meta.env[key];
  if (value === undefined) {
    throw new Error(`Env variable ${key} is required`);
  }
  return value;
};

/** App name for runtime context and library awareness */
export const APP_NAME = getEnvVar("VITE_APP_NAME");

/** Main site */
export const MAIN_SITE = getEnvVar("VITE_MAIN_SITE");

export const CUSTOMER_SITE = getEnvVar("VITE_CUSTOMER_SITE");

/**
 * API entrypoint
 *
 * Wrapped in getApiUrl so `?php_api_pr=123` / `?hw_api_pr=123` can point the app
 * at a PR preview environment instead of the configured default. The override is
 * ignored outside localhost / .testing. / .dev. hosts.
 */
export const API_URL = getApiUrl("php_api", getEnvVar("VITE_API_URL"));
export const HW_API_URL = getApiUrl("hw_api", getEnvVar("VITE_HW_API_URL"));

/** App model */
export const NODE_ENV = import.meta.env.PROD ? "production" : "development";

/** Development model */
export const isDevEnv = import.meta.env.DEV;

/** Production model */
export const isProdEnv = import.meta.env.PROD;

/** Old App link */
export const hunkwareAppURL = getEnvVar("VITE_DOMAIN_URL");

/** BugSnag Application ID **/
export const BUGSNAG_API_KEY = getEnvVar("VITE_BUGSNAG_API_KEY");

/** Google Application ID **/
export const GOOGLE_API_KEY = getEnvVar("VITE_GOOGLE_API_KEY");

/** Square Application ID **/
export const SQUARE_APP_ID = getEnvVar("VITE_SQUARE_APP_ID");

/** HUNKPAY CLIENT KEY **/
export const HUNKPAY_CLIENT_KEY = getEnvVar("VITE_HUNKPAY_CLIENT_KEY");

/** HUNKPAY ENV **/
export const HUNKPAY_ENV = getEnvVar("VITE_HUNKPAY_ENV");

/** Split.io Auth Key **/
export const SPLIT_AUTH_KEY = getEnvVar("VITE_SPLIT_AUTH_KEY");

/** GA4 ID **/
export const GA4_ID = getEnvVar("VITE_GA4_ID");

/** Is Sandbox **/
export const IS_SANDBOX = getEnvVar("VITE_IS_SANDBOX") === "true";
